import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

function Footer() {
  return (
    <footer className="custom-footer">
      <div className="container">
        <Row className="gy-4">
          {/* Column 1: Brand Info */}
          <Col lg={5} md={6}>
            <div className="pe-lg-4">
              <h5 className="footer-heading">Chandigarh Badminton Association</h5>
              <p className="text-muted small mb-3">
                Affiliated to the Badminton Association of India. Commited to development, training, and championships across Chandigarh state, helping shape the next generation of athletes.
              </p>
              <div className="d-flex align-items-center gap-2">
                <span className="small text-muted">Sponsored by:</span>
                <span className="badge bg-light text-dark px-2.5 py-1 fw-bold tracking-wide">YONEX</span>
              </div>
            </div>
          </Col>

          {/* Column 2: Quick Links */}
          <Col lg={3} md={6}>
            <h5 className="footer-heading">Quick Links</h5>
            <ul className="footer-links-list">
              <li>
                <Link to="/" className="footer-link">Home Page</Link>
              </li>
              <li>
                <Link to="/about" className="footer-link">About Us</Link>
              </li>
              <li>
                <Link to="/CBA_ID" className="footer-link">CBA ID Lookup</Link>
              </li>
              <li>
                <Link to="/events" className="footer-link">Notice & Events</Link>
              </li>
              <li>
                <Link to="/gallery" className="footer-link">Media Gallery</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-link">Contact Representatives</Link>
              </li>
            </ul>
          </Col>

          {/* Column 3: Contacts */}
          <Col lg={4} md={12}>
            <h5 className="footer-heading">Contact Details</h5>
            
            <div className="footer-contact-item">
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" className="footer-contact-icon">
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
              </svg>
              <div>
                <strong className="text-white d-block small">Representative</strong>
                <span className="small">Surinder Mahajan (Sr Vice President)</span>
              </div>
            </div>

            <div className="footer-contact-item">
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" className="footer-contact-icon">
                <path d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"/>
              </svg>
              <div>
                <strong className="text-white d-block small">Call Us</strong>
                <span className="small">+91-9815045900</span>
              </div>
            </div>

            <div className="footer-contact-item">
              <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16" className="footer-contact-icon">
                <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
              </svg>
              <div>
                <strong className="text-white d-block small">Email Inquiries</strong>
                <span className="small">mahajan_surinder@hotmail.com</span>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 footer-bottom-text">
          <p className="mb-0">&copy; 2025 Chandigarh Badminton Association. All rights reserved.</p>
          <p className="mb-0 text-muted small">Designed & Developed in collaboration with YONEX.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;